import React from "react";
import Modal from "react-bootstrap/Modal";
import { Spinner } from "../../Common";
import OutsideClickHandler from "react-outside-click-handler";
import { DropDownList, DropDownButton, InputBox, Button } from "../../Common";
import styles from "./partners.module.css";

const StatusUpdate = ({
  show,
  onClose,
  onSubmit,
  loading,
  statusMessage,
  status,
  setStatus,
  showStatusDropdown,
  setShowStatusDropdown,
}) => {
  const statusList = ["active", "inactive"];

  return (
    <Modal show={show} onHide={onClose} centered className={styles.statusModal}>
      <Modal.Header closeButton className={styles.statusHeader}>
        <Modal.Title>Update Partner Status</Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles.statusBody}>
        {loading ? (
          <div className={styles.loaderContainer}>
            <Spinner animation="border" variant="light" />
          </div>
        ) : (
          <>
            <div className={styles.statusFormGroup}>
              <label>
                Status <span className={styles.required}>*</span>
              </label>
              <div style={{ position: "relative" }}>
                <DropDownButton
                  onClick={() => setShowStatusDropdown(true)}
                  showDropDown={showStatusDropdown}
                  height={"40px"}
                >
                  {status ? (
                    <span className={styles.statusLabel}>{status}</span>
                  ) : (
                    <span className={styles.selectDropDown}>Select Status</span>
                  )}
                </DropDownButton>

                <OutsideClickHandler
                  onOutsideClick={() => setShowStatusDropdown(false)}
                >
                  <DropDownList
                    data={statusList}
                    showDropDown={showStatusDropdown}
                    onChange={(item) => {
                      setStatus(item);
                      setShowStatusDropdown(false);
                    }}
                    scrollbar={false}
                  />
                </OutsideClickHandler>
              </div>
            </div>

            {statusMessage && (
              <p
                className={
                  statusMessage.includes("successfully")
                    ? styles.successMessage
                    : styles.errorMessage
                }
                style={{
                  marginTop: "16px",
                  color: statusMessage.includes("successfully")
                    ? "#4CAF50"
                    : "#FF5252",
                }}
              >
                {statusMessage}
              </p>
            )}
          </>
        )}
      </Modal.Body>
      <div className={styles.statusbutton}>
        <Button onClick={onClose} title="Cancel" variant="secondary" />
        <Button
          onClick={onSubmit}
          title="Update Status"
          variant="primary"
          disabled={loading}
        />
      </div>
    </Modal>
  );
};

export default StatusUpdate;
